import { createContext, useContext } from 'react';
import type { RoleAvailability } from '../../../../types/UserManagementTypes';

// The stepper hands each step only its navigation callback, so wizard-wide
// values reach the steps through here rather than through step props.
export interface UserFormMeta {
  /** ISO date the client's subscription ends; caps the access expiry picker. */
  subscriptionEndDate?: string;
  isEditing?: boolean;
  /** The email the record had before editing, for the change-warning popup. */
  originalEmail?: string;
  /** Keyed by role name; absent entries are treated as available. */
  roleAvailability?: Record<string, RoleAvailability>;
}

export const UserFormMetaContext = createContext<UserFormMeta>({});

export const useUserFormMeta = () => useContext(UserFormMetaContext);
